import {AfterViewChecked, Component, ElementRef, Input, OnInit, ViewChild} from '@angular/core';
import {ChatMessage} from './models/chat-message';
import {IAlbum, Lightbox} from 'ngx-lightbox';
import {UserService} from '../../services/user/user.service';
import {displayMessageTimestamp} from '../../helpers/message-display/message-display';

@Component({
  selector:    'ngx-chat',
  templateUrl: './chat.component.html',
  styleUrls:   ['./chat.component.scss'],
})
export class ChatComponent implements OnInit, AfterViewChecked {
  @ViewChild('chatMessages') chatMessages: ElementRef;
  @ViewChild('chatContainer') chatContainer: ElementRef;

  @Input('messages') messages: Array<ChatMessage>;
  @Input('loading') loading: boolean = false;
  private initialLoad: boolean       = true;

  constructor(
    public lightbox: Lightbox,
    public user: UserService,
  ) {
  }

  ngOnInit() {
    this.scrollToBottom();
  }

  ngAfterViewChecked() {
    if (this.chatContainer.nativeElement.scrollTop !== this.chatContainer.nativeElement.scrollHeight) {
      if (this.initialLoad) {
        this.scrollToBottom();
        this.initialLoad = false;
      }
    }
  }

  openImage(message: ChatMessage, index: number) {
    const album: Array<IAlbum> = [];

    if (message.images) {
      for (const image of message.images) {
        const iAlbum: IAlbum = {
          src:     image.url,
          caption: '',
          thumb:   image.url,
        };

        album.push(iAlbum);
      }

      this.lightbox.open(album, index);
    }
  }

  displayTimestamp(value) {
    return displayMessageTimestamp(value);
  }

  scrollToBottom() {
    this.chatContainer.nativeElement.scrollTop = 0
    // const els = document.getElementsByClassName('chat-scroller');
    // if (els.length) {
    //   const el = els[0];
    //   el.scrollTop = el.scrollHeight;
    // }
    //
    // this.chatContainer.nativeElement.scrollTop = this.chatContainer.nativeElement.scrollHeight;
    // setTimeout(() => {
    //   this.chatContainer.nativeElement.scrollTop = this.chatContainer.nativeElement.scrollHeight;
    // }, 250);
  }
}
